// Ticket status metadata shared across components. Colors map to the
// --bx-status-* design tokens defined in index.html.

export const STATUSES = ['new', 'open', 'pending', 'solved', 'closed']

export const STATUS_LABEL = {
  new: 'New',
  open: 'Open',
  pending: 'Pending',
  solved: 'Solved',
  closed: 'Closed'
}

export function statusColor(status) {
  return `var(--bx-status-${status}, var(--bx-muted))`
}

// Status badge colors on the BrandExtract design system (background + foreground).
// Used by the redesigned ticket list and ticket detail badges.
export const STATUS_STYLE = {
  new: { bg: 'var(--chartreuse-500)', fg: 'var(--eggplant-500)' },
  open: { bg: 'var(--sky-500)', fg: 'var(--white)' },
  pending: { bg: 'var(--chartreuse-700)', fg: 'var(--white)' },
  solved: { bg: 'var(--eggplant-600)', fg: 'var(--white)' },
  closed: { bg: 'var(--neutral-500)', fg: 'var(--white)' }
}

export function formatDate(iso) {
  if (!iso) return '—'
  const d = new Date(iso)
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })
}
